import { motion } from "framer-motion";

const RULES = [
  "10–12 oz padded gloves for all masters division bouts",
  "Shorter championship round formats for veteran fighters",
  "Mandatory ringside physician and medical team at every event",
];

export default function Regulation() {
  return (
    <section className="py-24 lg:py-32" data-testid="regulation-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <div className="relative border border-zinc-800 overflow-hidden">
            <div className="absolute inset-0 border border-[#E10600]/30 translate-x-2 translate-y-2 -z-10" />
            <img
              src="/images/gloves-regulation.jpeg"
              alt="Regulation issue padded boxing gloves"
              className="w-full h-[320px] sm:h-[420px] object-cover object-center"
              data-testid="regulation-gloves-image"
            />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/90 to-transparent p-6">
              <p className="font-mono2 text-[10px] tracking-[0.4em] text-[#E10600] uppercase mb-1">Regulation Issue</p>
              <p className="font-display text-3xl sm:text-4xl uppercase text-white">10–12 oz Padded Gloves</p>
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <p className="font-mono2 text-[10px] sm:text-xs tracking-[0.4em] text-[#E10600] uppercase mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#E10600]" /> The Rules
          </p>
          <h2 className="font-display text-5xl sm:text-6xl uppercase leading-[0.9] text-white">
            Veteran rules, <span className="text-[#E10600]">champion</span> standards
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-xl">
            Every masters division bout is fought under equipment and round rules engineered for fighters
            aged 40–55 — maximum protection, zero compromise on legitimacy.
          </p>
          <ul className="mt-8 space-y-3">
            {RULES.map((t, i) => (
              <motion.li
                key={t}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15 + i * 0.1, duration: 0.6 }}
                className="flex items-center gap-3 text-zinc-300 text-sm sm:text-base"
              >
                <span className="h-2 w-2 rotate-45 bg-[#E10600] shrink-0" /> {t}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
